import script from "./concat.vue?vue&type=script&lang=ts&setup=true"
export * from "./concat.vue?vue&type=script&lang=ts&setup=true"

import "./concat.vue?vue&type=style&index=0&id=5eec6e60&lang=scss"

const __exports__ = script;

export default __exports__